import { CloseCircleOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client';
import Spinner from '@Assets/spinner.svg?react';
import {
  DeleteAssignmentMediaSimpleDocument,
  HomePageArtworkMediaFragment,
} from '../../../../services/graphql/types/graphql';
import { DELETE_ASSIGNMENT_MEDIA_DRAFT } from '../../../../services/graphql/draftAssignment.operations';
import { AssignmentMediaViewer } from '../../../../components/AssignmentMediaViewer';

export const ArtworkItem = ({
  assignmentId,
  data,
  deleteAble = true,
  draftMode = false,
  refetchQueries = ['GetTeacherEvaluationPage'],
  ...props
}: React.HTMLAttributes<HTMLDivElement> & {
  assignmentId: string;
  data: HomePageArtworkMediaFragment;
  deleteAble: boolean;
  draftMode?: boolean;
  refetchQueries?: string[];
}): JSX.Element => {
  const [deleteArtworkMutation, { loading }] = useMutation(
    draftMode ? DELETE_ASSIGNMENT_MEDIA_DRAFT : DeleteAssignmentMediaSimpleDocument,
    { refetchQueries },
  );

  const media = data;

  const onClickDeleteButton = (e: React.MouseEvent) => {
    e.stopPropagation();
    deleteArtworkMutation({
      variables: draftMode
        ? { assignmentId, mediaId: media.mediaId, draftMode: true }
        : { assignmentId, mediaId: media.mediaId },
    })
      .then(() => {
        console.info(`Delete media ${media.mediaId}`);
      })
      .catch(console.error);
  };

  return (
    <div className="absolute inset-0 overflow-hidden bg-white" {...props}>
      {media?.url && (
        <>
          <AssignmentMediaViewer url={media.url} />
          <div className="absolute right-[5px] top-[5px] z-20 flex h-6 w-6 items-center justify-center text-2xl leading-6 text-[#7d7d7d]">
            {deleteAble &&
              (loading ? (
                <Spinner></Spinner>
              ) : (
                <CloseCircleOutlined onClick={onClickDeleteButton} />
              ))}
          </div>
        </>
      )}
    </div>
  );
};
